import { render, staticRenderFns } from "./SeminarDownloader.vue?vue&type=template&id=6150fe9d&"
import script from "./SeminarDownloader.vue?vue&type=script&lang=js&"
export * from "./SeminarDownloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports